import { UrlQueryOperator } from '/@/modules/core/app/constants/UrlQueryOperator';
import { TableFilter } from '/@/modules/core/table/models/TableFilter';
import { TableFilterMixin } from '/@/modules/core/table/mixins/TableFilterMixin';
import EventBus from '/@/modules/core/app/helpers/EventBus';
import { FormMultiSelectEvent } from '@/modules/core/form/constants/FormMultiSelectEvent';

export const CustomTableFilterMixin = {
  mixins: [TableFilterMixin],
  props: {
    tableFilter: {
      type: TableFilter,
      required: true
    }
  },
  data() {
    return {
      filter: this.tableFilter,
      value: null,
      showValueSelect: false,
      customQueryOperatorConfig: null
    };
  },
  methods: {
    setMultiple(operatorKey) {
      this.tableFilter.customTableFilter.setMultiple(
        UrlQueryOperator.isOperatorMultiple(operatorKey)
      );
      this.showValueSelect = false;
      this.$nextTick(() => {
        this.showValueSelect = true;
      });
    },
    onQueryOperatorSelect(operator) {
      this.value = null;
      this.tableFilter.setValue(null);
      this.setMultiple(operator.key);
    },
    onValueSelect() {
      this.tableFilter.setValue(this.value);
    },
    onOptionsPopulated(options) {
      if (this.value || !this.tableFilter.value) {
        return;
      }

      this.setSelectedValueFromTableFilter(options);
    },
    async setSelectedValueFromTableFilter(options) {
      if (!Array.isArray(this.tableFilter.value)) {
        this.value = this.tableFilter.value;
        return;
      }

      const localOptions = this.tableFilter.customTableFilter.config.hasGrouping
        ? this.tableFilter.customTableFilter.config.getFlattenedGroupedOptions(options)
        : options;
      this.value = localOptions?.filter((option) =>
        this.tableFilter.value.includes(option[this.tableFilter.trackBy])
      );

      if (
        this.tableFilter.customTableFilter.config.isAsync &&
        this.value.length !== this.tableFilter.value.length
      ) {
        this.setAsyncSelectedValueFromTableFilter();
      }
    },
    async setAsyncSelectedValueFromTableFilter() {
      const trackByValueIds = this.value.map((value) => value[this.tableFilter.trackBy]);
      const asyncIds = this.tableFilter.value.filter((value) => !trackByValueIds.includes(value));

      // Get the value if it does not exist in the paginated options yet
      const asyncValues = await this.tableFilter.customTableFilter.config.getOptions({
        [this.tableFilter.trackBy]: asyncIds
      });

      this.value = this.value.concat(asyncValues);

      if (this.value.length) {
        EventBus.signal(
          `${FormMultiSelectEvent.ASYNC_SELECTED_OPTION_LOADED}${this.valueFormSelectId}`,
          asyncValues
        );
      }
    }
  },
  created() {
    if (this.tableFilter.value) {
      this.setMultiple(this.tableFilter.operator);
    }
  },
  mounted() {
    // When there is only 1 operator present, select it by default
    const operators = this.tableFilter.customTableFilter.operators || this.operatorOptions;
    if (!this.filter.operator && operators.length === 1) {
      const operator = operators[0];
      this.filter.operator = operator.key;
      this.onQueryOperatorSelect(operator);
    }
  }
};
